<template>
  <div class="form-content">
    <el-form :model="itemdata" :ref="`form[${item.uuid}]`">
      <form-items v-model="itemdata" v-bind:items="items" :editable="editable" :deep="deep+1" :editStatus="editStatus"/>
    </el-form>
  </div>
</template>

<script>
	import FormItems from '../FormItems'
	import { mapGetters } from 'vuex'
	export default {
		name: 'datamodel-widget',
		props: {
			editable: { type: Boolean },
			item: { type: Object},
			value: { type: Object },
			deep: Number,
			editStatus: String
		},
		beforeDestroy() {
			let result = this.$store.getters.getFormSet.slice().filter(item => item !== undefined)
			let name = `form[${this.item.uuid}]`
			let delIndex
			result.forEach((form, index) => {
				if (form === name) {
					delIndex = index
				}
			})
			result.splice(delIndex, 1)
			this.$store.dispatch('setFormSet', result)
		},
		data() {
			return {
				items: []
			}
		},
		components: { FormItems },
		methods: {
			loader() {
				this.items = this.item.content
			}
		},
		computed: {
			...mapGetters({childModel: 'getChildModel'}),
			itemdata: {
				get() {
					return this.value || {}
        },
				set(itemdata) { this.$emit('input', itemdata) }
			}
		},
		mounted() {
			this.loader()
			let result = this.$store.getters.getFormSet.slice().filter(item => item !== undefined)
			let name = `form[${this.item.uuid}]`

			this.$refs[name] && result.push(this.$refs[name])
			this.$store.dispatch('setFormSet', result)
		}
	}
</script>


<style scoped>
  .form-content h4 {
    margin-top: 10px;
    margin-bottom: 10px;
  }
</style>

